const qs = require('qs');

export const LEDGER_SCOPE_FILTER_IDS = ['venue_ownership_id', 'data_source', 'import_run_id'];

export const GENERAL_LEDGER_REPORT = 'general_ledger';
export const SALES_TAX_REPORT = 'sales_tax';

export const DATA_SOURCE_OPTIONS = [
  { value: 'imported', label: 'Imported only' },
  { value: 'native', label: 'Opendate-native only' },
];

// Ledger days (posting and event dates) arrive as venue-local YYYY-MM-DD dates; render them
// as-is rather than through a Date in the viewer's or team's zone, which would shift them.
export const formatLedgerDay = (value) => {
  if (!value) return '—';
  const [year, month, day] = String(value).slice(0, 10).split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
};

export const ledgerScopeParams = (dateRange, activeFilters = {}) => {
  const params = {};
  if (dateRange?.start) params.start_date = dateRange.start;
  if (dateRange?.end) params.end_date = dateRange.end;
  LEDGER_SCOPE_FILTER_IDS.forEach((id) => {
    if (activeFilters[id]?.length) params[id] = activeFilters[id];
  });
  return params;
};

export const generalLedgerRowSelection = (row) => ({
  source: [row.source],
  general_ledger_code: [row.general_ledger_code],
  ...(row.event_key ? { event_key: row.event_key } : {}),
  ...(row.event_search ? { event_search: row.event_search } : {}),
});

export const salesTaxRowSelection = (row) => ({
  source: ['Tax'],
  tax_name: [row.tax_name],
  tax_rate: String(row.rate),
  ...(row.general_ledger_code ? { general_ledger_code: [row.general_ledger_code] } : {}),
});

export const ledgerLineItemsHref = (teamId, report, params) => (
  `/teams/${teamId}/reporting/finances/general-ledger/line-items?${qs.stringify({ ...params, report }, { arrayFormat: 'brackets' })}`
);

export const ledgerLineItemExportsPath = (teamId) => `/teams/${teamId}/reporting/finances/general-ledger/line-item-exports`;

export const ledgerReportHref = (path, params) => {
  const scope = ledgerScopeParams({ start: params.start_date, end: params.end_date }, params);
  const query = qs.stringify(scope, { arrayFormat: 'brackets' });
  return query ? `${path}?${query}` : path;
};
